import { Box } from "@mui/material";
import styles from "./HomeHero.module.css";

interface Props {
  backgroundImage: string;
  backgroundSize?: string;
  backgroundPosition?: string;
  content: JSX.Element;
  actions: JSX.Element;
}

const HomeHero = ({
  backgroundImage,
  backgroundSize = "124%",
  backgroundPosition = "left 48%",
  ...props
}: Props): JSX.Element => {
  return (
    <div
      className={styles.heroBanner}
      style={{
        background: `linear-gradient(269.47deg, rgba(255, 255, 255, 0) 51.7%, #FFFFFF 97.87%), url(${backgroundImage})`,
        backgroundSize: `auto, ${backgroundSize}`,
        backgroundPosition: `left top, ${backgroundPosition}`,
      }}
    >
      <Box className={styles.contentContainer}>
        {props.content}
        <Box className={styles.buttonContainer}>{props.actions}</Box>
      </Box>
    </div>
  );
};

export default HomeHero;
